// analyticsConfig.js
// Single source of truth for the Google Analytics measurement ID, imported by main.js (plugin
// registration) and App.vue (per-session setOptions). Previously the ID was written out in six
// places; one shared constant means it can't drift.
//
// History (Jul 2026): the app configured the legacy UA property "UA-59943727-3", which stopped
// collecting in 2023. Data still reached GA4 because Google's connected-site-tag forwarding
// silently redirected hits from the UA tag to the linked GA4 property — confirmed by inspecting a
// live request: the browser posted to google-analytics.com/g/collect with v=2 and
// tid=G-TBD5BRF0PC despite the code naming the UA ID.
//
// That forwarding is deprecated plumbing: if Google retires it, collection stops silently with no
// error. Naming the GA4 property directly removes that dependency. This is a replacement, not an
// addition, so there is no double counting — gtag loads with the GA4 ID and the forwarding path is
// simply unused.
export const GA_MEASUREMENT_ID = "G-TBD5BRF0PC";